export default {
	  bind: function (el, binding, vnode) {
		  el.draggable=true;
		  el.style.cursor='move';
		  el.style.position=binding.value?'fixed':'absolute';
		if(!el.id)el.id='mymove'+(new Date()).getTime();
		//var hammertime = new Hammer(el);
		
		  console.log('指令',binding.name,'把id为：',el.id,'的对象设置为了',el.style.position)
		  var dragstart=function(event){
				event.dataTransfer.setData("id",event.target.id);
				event.dataTransfer.setData("x",event.pageX);
				event.dataTransfer.setData("y",event.pageY);
			}
			/* var drop=function (event){
				console.log(event)
			} */
			//hammertime.on("panstart",dragstart);
			//hammertime.on("panmove",drop);
			el.addEventListener('dragstart',dragstart)
		},
	}


// WEBPACK FOOTER //
// ./src/vue/directive/v-mymove.js